import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocuments = createSelector(
  [
    (store: RootState) => store.supervisorHome.documents,
    (store: RootState) => store.supervisorHome.documentSearchText,
  ],
  (documents, searchText) => (
    documents.filter(({ searchDocumentText }) =>
      searchDocumentText?.toLowerCase().includes((searchText || "").toLowerCase() || "")
    )
  )
);
